<script setup lang="ts">
import { PV } from "@/widgets";
import { unref, type Component, type MaybeRef } from "vue";

const props = defineProps<{
    label?: string;
    icon?: Component;
    formId?: string;
    severity?: string;
    isLoading?: MaybeRef<boolean>;
}>();
</script>

<template>
    <PV.Button
        :disabled="unref(props.isLoading) === true"
        :form="props.formId"
        :severity="props.severity"
        type="button"
    >
        <span class="inline-flex flex-row items-center gap-1">
            <component :is="props.icon" v-if="props.icon !== undefined" />
            <span class="font-semibold">{{ props.label ?? "Simpan" }}</span>
            <i v-if="unref(props.isLoading) === true" class="pi pi-spin pi-spinner ml-2" style="font-size: 1rem" />
        </span>
    </PV.Button>
</template>
